import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.jsx';
import AuthCheck from './components/AuthCheck.jsx';

const root = createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AuthCheck>
      <App />
    </AuthCheck>
  </React.StrictMode>
);